import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { generateCustomizedSyncBody } from 'utils/CustomizedSync'
import { INTEGRATION_TYPE } from 'utils/integrations'

import { addToast } from 'containers/Toasts/actions'

import {
  fetchDataError,
  fetchDataSuccess,
  submitCustomizedSyncError,
  submitCustomizedSyncSuccess,
} from './actions'
import {
  DATA_REQUEST_ASYNC,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC,
} from './constants'

const fetchDataEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(DATA_REQUEST_ASYNC.INITIATE, SEARCH_CHANGE, PAGINATE_CHANGE).mergeMap(() =>
    api.mailboxes
      .getCustomizedAutoSyncData(
        store.getState().partnerOptions.selectedCompany?.value,
        store.getState().customizedautosync.self.integrationType,
        store.getState().customizedautosync.self.search,
        store.getState().customizedautosync.self.integrationType === INTEGRATION_TYPE.GSUITE &&
          store.getState().mailboxes.upload.gdAdminEmail,
        store.getState().customizedautosync.self.page || 1
      )
      .map((response) => fetchDataSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(fetchDataError, error)))
  )

const submitCustomizedSyncEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC.INITIATE).mergeMap(() =>
    api.mailboxes
      .updateCustomizedAutoSyncData(
        store.getState().partnerOptions.selectedCompany?.value,
        generateCustomizedSyncBody(store)
      )
      .map((response) => submitCustomizedSyncSuccess(response))
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(submitCustomizedSyncError, error),
          addToast({ message: error.response?.message, type: 'error' })
        )
      )
  )

export default combineEpics(fetchDataEpic, submitCustomizedSyncEpic)
